module.exports = "/images/Kid rides.svg?d61b63c9ef2d7ffabcd57b9e4cb29a45";